import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '../../../../utils/numbers';
import { EditIcon } from '../../icons';

const OffersV4Hero = ({ amount, onEditClick }) => (
    <div className="offers-v4-hero">
        <div className="offers-v4-hero__inner">
            <div className="offers-v4-hero__metadata">
                <span className="offers-v4-hero__label">Loan amount</span>
                <div className="offers-v4-hero__amount-row">
                    <span className="offers-v4-hero__amount">
                        {formatMoney(amount)}
                    </span>
                    <button
                        id="offers-v4-edit-amount"
                        className="offers-v4-hero__edit-btn"
                        onClick={onEditClick}
                        aria-label="Edit loan amount"
                        type="button"
                    >
                        <EditIcon />
                    </button>
                </div>
            </div>
        </div>
    </div>
);

OffersV4Hero.propTypes = {
    amount: PropTypes.number.isRequired,
    onEditClick: PropTypes.func.isRequired,
};

export default OffersV4Hero;
